import { render, staticRenderFns } from "./DetalhesContribuinte.vue?vue&type=template&id=1252e02d&"
import script from "./DetalhesContribuinte.vue?vue&type=script&lang=js&"
export * from "./DetalhesContribuinte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports